(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.r_hubspot_forms = {
    attach: function (context, settings) {
      $('form').each(function () {
        // Add boostrap classes to HubspotForm
        $(this).find('.hs-fieldtype-select .input').addClass('form-wrapper');
        $(this)
          .find('.hs-fieldtype-select .input select')
          .addClass('form-control')
          .once('wrapped')
          .wrap("<div class='select-wrapper'></div>");

        $(this).find('.hs-fieldtype-text .input').addClass('form-wrapper');
        $(this).find('.hs-fieldtype-text .input input').addClass('form-control');

        $(this).find('.hs-fieldtype-textarea .input').addClass('form-wrapper');
        $(this)
          .find('.hs-fieldtype-textarea .input textarea')
          .addClass('form-control')
          .once('wrapped')
          .wrap("<div class='form-textarea-wrapper'></div>");

        $(this).find('.hs-fieldtype-date .input').addClass('form-wrapper');

        // @TODO Move to attachBehaviors, this is being deprecated
        $(this)
          .find('.form-textarea-wrapper')
          .once('domed')
          .bind('DOMSubtreeModified', function (e) {
            Drupal.attachBehaviors();
          });
      });
    }
  };
})(jQuery, Drupal);
